import {
  STORE_USER
} from '../actions/types'

const userReducer = function (state = { }, action) {
  switch (action.type) {
    case STORE_USER:
      return {
        ...state,
        ...action.user
      }
    default:
      return state
  }
}
export default userReducer



// WEBPACK FOOTER //
// /app/js/reducers/userReducer.js